import './elenco-articoli.scss';

/**
 * version    1.0
 * class      <type> (ElencoArticoli)
 * classdesc
 */
export class ElencoArticoli {}
